import { SupportedCodeScreens } from 'app/area/codetable/item/screen-renderer/types';
import { Slot } from 'app/area/codetable/item/types';
import { CodetableMetadata } from 'app/area/codetable/types-store';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';

export const shouldRenderTypes = (metadata: CodetableMetadata, sectionSlots?: Slot) =>
  (metadata && metadata.codetableClass && isDefinedIncludingZero(metadata.codetableClass.id)) || !!sectionSlots;

export const shouldRenderDetails = (metadata: CodetableMetadata, sectionSlots?: Slot) =>
  (!!metadata && (!!metadata.codetableCategory || !!metadata.features && (metadata.features.disabled || metadata.features.sequence
    || metadata.features.hierarchy || (!!metadata.codetableNode && !!metadata.codetableNode.id)))) || !!sectionSlots;

export const shouldRenderVisibility = (metadata: CodetableMetadata, sectionSlots?: Slot) =>
  (!!metadata && !!metadata.features && (metadata.features.userGroup || metadata.features.caseType || metadata.features.visible)) ||
  !!sectionSlots;

export const shouldRenderTranslations = (metadata: CodetableMetadata, sectionSlots?: Slot) =>
  (!!metadata && !!metadata.features && !!metadata.features.description) || !!sectionSlots;

export const shouldRenderScalarValues = (metadata: CodetableMetadata, sectionSlots?: Slot) =>
  (!!metadata && !!metadata.codetable && isDefinedIncludingZero(metadata.codetable.id) &&
    [SupportedCodeScreens.ConsequencesSeverity, SupportedCodeScreens.ConsequencesRecurrence, SupportedCodeScreens.ConsequencesLikelihood]
      .includes(metadata.codetable.id)) || !!sectionSlots;
